module.exports = __webpack_public_path__ + "img/catamnesis3.e7282387.jpg";